import { InvokeApi } from "../../Utils/InvokeApi";

export const CreateBookChapter = async (data) => {
  const requestObj = {
    path: `/chapter/create`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};

export const UpdateBookChapter = async (chapterId, data) => {
    const requestObj = {
      path: `/chapter/${chapterId}`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      postData: data,
    };
    return InvokeApi(requestObj);
  };
  

export const GetBookChapters = async (data) => {
  const { page, limit, bookId, key, value } = data;
  const params = new URLSearchParams();
  if (data !== false) {
    params.set('page', page >= 0 ? page.toString() : "");
    params.set('limit',limit ? limit.toString() : "");
    if(bookId) params.set('bookId', bookId);
  // Only include key and value if both are provided
  if (key && value) {
    params.set('key', key);
    params.set('value', value);
  }
}
  let paramQuery = data !== false ? params.toString() : ""
  const requestObj = {
    path: `/chapter?${paramQuery}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};

export const DeleteBookChapter = async (chapterId) => {
    const requestObj = {
      path: `/chapter/${chapterId}`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        "Content-Type": "application/json",
      },
    };
    return InvokeApi(requestObj);
};

